import React from 'react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';

const MyTeams = ({teams, editCallback, myTeamsType}) => {

    const teamStatuses = [
        {
            id: 1,
            status: 'Creating',
            label: 'Creating'
        },
        {
            id: 2,
            status: 'PendingApproval',
            label: 'Pending Approval'
        },
        {
            id: 3,
            status: 'Active',
            label: 'Active'
        },
        {
            id: 4,
            status: 'Expired',
            label: 'Expired'
        },
        {
            id: 5,
            status: 'Disabled',
            label: 'Disabled'
        },
        {
            id: 6,
            status: 'Deleted',
            label: 'Deleted'
        },
        {
            id: 7,
            status: 'Canceled',
            label: 'Canceled'
        },
        {
            id: 8,
            status: 'Rejected',
            label: 'Rejected'
        },
        {
            id: 9,
            status: 'Archived',
            label: 'Archived'
        }
    ]

    const teamsToDisplay = teamStatuses.map(x=> 
        <TileGroup  
            key={x.id}
            groupBy={x.label} 
            elements={teams.filter(team => (team.siteStatus === x.status)).map(s =>
                <SingleSite
                    key={s.id}
                    site={s}
                    callBack={id => editCallback(id, myTeamsType, 'Site')}
                />)}
        />)

    return(
        <div>
            {teamsToDisplay}
        </div>
    );
}

export default MyTeams


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyTeams.js